module.exports = __webpack_public_path__ + "img/dmp5.9bf82559.png";